"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRatingsCall = exports.getComments = exports.getAuthorInfo = exports.getPostsCall = exports.getFeedByRole = void 0;
var axios_1 = __importDefault(require("axios"));
var catchAxiosError_1 = __importDefault(require("../catchAxiosError"));
function getFeedByRole(_a) {
    var payload = _a.payload;
    var token = payload.token;
    var _b = payload.params, page = _b.page, queryParams = _b.queryParams;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/role/feed"), {
        page: page,
        queryParams: queryParams,
        token: token
    })
        .catch(catchAxiosError_1.default);
}
exports.getFeedByRole = getFeedByRole;
function getPostsCall(_a) {
    var payload = _a.payload;
    var token = payload.token;
    var _b = payload.params, page = _b.page, queryParams = _b.queryParams;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/feed"), {
        page: page,
        queryParams: queryParams,
        token: token
    })
        .catch(catchAxiosError_1.default);
}
exports.getPostsCall = getPostsCall;
function getAuthorInfo(id) {
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/").concat(id));
}
exports.getAuthorInfo = getAuthorInfo;
function getComments(postId) {
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/comments?post=").concat(postId));
}
exports.getComments = getComments;
function getRatingsCall(_a) {
    var payload = _a.payload;
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/postratings?post_id=").concat(payload));
}
exports.getRatingsCall = getRatingsCall;
